export default "__VITE_ASSET__9Hufi8Gj__"